import { EntitlementExceptionsActionKind } from './actions';
export const entitlementExceptionsReducer = (state, { type, payload }) => {
    switch (type) {
        case EntitlementExceptionsActionKind.ModifyEntitlementExceptions: {
            return { ...payload };
        }
        default: {
            return state;
        }
    }
};
